import { ROLES } from '@/constants';
import checkRole from '@/lib/checkRole';
import userService from '@/services/API/user';
import { apiService } from '@/services/APIService';
import JWTService from '@/services/JWTService';

export default {
  name: 'auth',
  namespaced: true,
  state: {
    user: {},
    authenticated: true,
  },
  getters: {
    isAuthenticated(state) {
      return state.authenticated;
    },
    getUser(state) {
      return state.user;
    },
    userRole(state) {
      return state.user.roles || [];
    },
    isAdmin(_, getters) {
      return checkRole(getters.userRole, ROLES.admin);
    },
    isSupport(_, getters) {
      return checkRole(getters.userRole, ROLES.support);
    },
    isRegion(_, getters) {
      return checkRole(getters.userRole, ROLES.region);
    },
    isMunicipality(_, getters) {
      return checkRole(getters.userRole, ROLES.municipality);
    },
    timezone(state) {
      return state.user?.timezone?.zone || 'Europe/Moscow';
    },
    timezoneValue(state) {
      return state.user.timezone.title.slice(4);
    },
  },
  actions: {
    init({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const token = JWTService.getToken();
        if (!token) {
          commit('LOGOUT_USER', {});
          reject();
          return;
        }
        const params = {
          expand: 'region_id,region,municipality_id,email_setting,actions',
        };
        apiService.mountAuthInterceptors();

        userService.userMe(params).then(async (response) => {
          const user = response.data.data;
          await dispatch('notification/init', null, { root: true });
          commit('SET_USER', user);
          resolve();
        }).catch(() => {
          reject();
          commit('LOGOUT_USER', {});
          JWTService.clearTokens();
        });
      });
    },

    logout({ commit }) {
      JWTService.clearTokens();
      commit('LOGOUT_USER');
      commit('notification/DELETE_CENTRIFUGE', null, { root: true });
    },

    setRefreshToken({ commit }, token) {
      commit('SET_REFRESH_TOKEN', token);
    },
  },
  mutations: {
    SET_USER(state, data) {
      state.user = data;
      state.authenticated = true;
    },
    LOGOUT_USER(state) {
      JWTService.clearTokens();
      state.user = {};
      state.authenticated = false;
    },
  },
};
